import { fapp } from '../../fapp'
import template from './change-password.html'

const pageChangePassword = () => {
  return {
    title: 'СМЕНИТЬ ПАРОЛЬ',
    currentShow: false,
    newShow: false,
    currentPassword: '',
    newPassword: '',
    async init() {
      this.$nextTick(_ => {
        this.$el.innerHTML = template
      })
    },
    async changePassword() {
      try {
        await fapp.service('/api/users').patch(this.app.user.id, {
          currentPassword: this.currentPassword,
          password: this.newPassword
        })
        this.$store.message.success('Пароль изменен')
        this.currentPassword = ''
        this.newPassword = ''
      } catch (e) {
        this.$store.message.error(e.message)
      }
    }
  }
}

export { pageChangePassword }
